/* eslint-disable react/require-default-props */
import * as React from 'react';
import { Button } from '@teamsnap/teamsnap-ui';
import { TEAMSNAP_URL } from '../../core/constants';
import FormModal, { FormOperation } from './FormModal';

interface Props {
  orgId: number;
  orgRegtype: string;
  isModalOpen: boolean;
  setIsModalOpen: (boolean) => void;
  onClickReg2?: () => void;
}

const NewFormButton: React.FC<Props> = ({ orgId, orgRegtype, isModalOpen, setIsModalOpen, onClickReg2 }) => {
  const [isNewClassicFormModalOpen, setIsNewClassicFormModalOpen] = React.useState<boolean>(false);

  const handleOnClickReg2 = () => {
    if (onClickReg2) {
      onClickReg2();
    } else {
      setIsModalOpen(!isModalOpen);
    }
  };

  return (
    <>
      {orgRegtype === 'reg1' && (
        <div className="Grid-cell u-xs-size1of2 u-textRight button-list">
          <Button
            testId="new-form-button"
            color="primary"
            icon="plus"
            iconPosition="left"
            onClick={() => setIsNewClassicFormModalOpen(!isNewClassicFormModalOpen)}
          >
            New Form
          </Button>
        </div>
      )}

      {orgRegtype === 'both' && (
        <div className="Grid-cell u-xs-size1of2 u-textRight button-list">
          <a
            title="Learn more about classic registration vs our new registration tool"
            href="/"
            target="_blank"
            rel="noreferrer"
            className="u-padRightSm"
          >
            Learn More
            <svg
              width="14"
              height="14"
              viewBox="0 0 13 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="Icon u-spaceLeftXs"
            >
              <path
                d="M10.25 10.8652H2.75C2.39844 10.8652 2.13477 10.6016 2.13477 10.25V2.75C2.13477 2.39844 2.39844 2.13477 2.75 2.13477H5.88477C6.20703 2.13477 6.5 1.8418 6.5 1.49023C6.5 1.16797 6.20703 0.875 5.88477 0.875H2.13477C1.43164 0.875 0.875 1.43164 0.875 2.13477V10.8652C0.875 11.5684 1.43164 12.125 2.13477 12.125H10.8652C11.5684 12.125 12.125 11.5684 12.125 10.8652V7.11523C12.125 6.79297 11.832 6.5 11.5098 6.5C11.1582 6.5 10.8652 6.79297 10.8652 7.11523V10.25C10.8652 10.6016 10.6016 10.8652 10.25 10.8652ZM7.75977 1.49023C7.75977 1.8418 8.02344 2.13477 8.375 2.13477H9.98633L4.27344 7.81836C4.03906 8.08203 4.03906 8.46289 4.27344 8.72656C4.53711 8.96094 4.91797 8.96094 5.18164 8.72656L10.8652 3.01367V4.625C10.8652 4.97656 11.1582 5.24023 11.5098 5.24023C11.832 5.24023 12.125 4.97656 12.125 4.625V1.49023C12.125 1.16797 11.832 0.875 11.5098 0.875H8.375C8.02344 0.875 7.75977 1.16797 7.75977 1.49023Z"
                fill="#2776F0"
              />
            </svg>
          </a>
          <Button
            testId="new-form-button"
            icon="plus"
            iconPosition="left"
            onClick={() => setIsNewClassicFormModalOpen(!isNewClassicFormModalOpen)}
          >
            Classic Registration
          </Button>
          <Button
            testId="new-form2.0-button"
            color="primary"
            icon="plus"
            iconPosition="left"
            onClick={handleOnClickReg2}
          >
            Create New Registration
          </Button>
        </div>
      )}

      {orgRegtype === 'reg2' && (
        <div className="Grid-cell u-xs-size1of2 u-textRight button-list">
          <Button
            testId="new-form2.0-button"
            color="primary"
            icon="plus"
            iconPosition="left"
            onClick={handleOnClickReg2}
          >
            Create New Registration
          </Button>
        </div>
      )}

      { isNewClassicFormModalOpen ? (
        <FormModal
          type={FormOperation.New}
          orgId={orgId}
          show={isNewClassicFormModalOpen}
          onSubmit={({ season }) => {
            window.location.href = `${TEAMSNAP_URL}/divisions/${season.tsDivisionId}/registration/new`;
          }}
          onCancel={() => {
            setIsNewClassicFormModalOpen(false);
          }}
          heading="New Registration Form"
          subheading={<p className="help-text">Please select where you would like to create this new form.</p>}
          submitButtonText="Continue"
          testId="new-form-modal"
        />
      ) : null}
    </>
  );
};

export default NewFormButton;
